
import './_url.scss';
import { Vue, Options } from 'vue-class-component';

@Options({
  props: {
    url: Object,
  },
  methods: {
    truncate(text: string): string {
      if (text.length > 26) {
        return `${text.substr(0, 26)}...`;
      }
      return text;
    },
  },
})

export default class Url extends Vue {
}
